import { render, staticRenderFns } from "./UnBind.vue?vue&type=template&id=bf845498"
import script from "./UnBind.vue?vue&type=script&lang=js"
export * from "./UnBind.vue?vue&type=script&lang=js"
import style0 from "./UnBind.vue?vue&type=style&index=0&id=bf845498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports